import { render, staticRenderFns } from "./tiendas.vue?vue&type=template&id=326caf69&scoped=true&"
import script from "./tiendas.vue?vue&type=script&lang=js&"
export * from "./tiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326caf69",
  null
  
)

export default component.exports